// Function loadUpcomingEventsContainerBlock loads the UpcomingEventsContainerBlock class by dynamically importing the js on demand if needed

export function loadUpcomingEventsContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-upcoming-events-container-block-chunk" */ '../widgets/upcomingEventsContainerBlock').then(wg => {

		const { UpcomingEventsContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="UpcomingEventsContainerBlock"]');

		if(!$wg) {
			// console.info('UpcomingEventsContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="UpcomingEventsContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new UpcomingEventsContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new UpcomingEventsContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the UpcomingEventsContainerBlock widget');

}
